import { DynamicLegalPage } from "./DynamicLegalPage";
import { useTranslation } from "react-i18next";

export function PrivacyPage() {
  const { t } = useTranslation();
  const sections = (() => {
    const v = t("privacy.page.sections", { returnObjects: true });
    return Array.isArray(v) ? (v as Array<{ title: string; body: string }>) : [];
  })();
  return (
    <DynamicLegalPage
      slug="confidentialite"
      fallback={{
        eyebrow: t("privacy.page.eyebrow"),
        title: t("privacy.page.title"),
        intro: t("privacy.page.intro"),
        sections,
      }}
    />
  );
}
